// extracted by mini-css-extract-plugin
export var bubble = "_3a-0";
export var container = "_3a-f";
export var contrastBorder = "_3a-g";
export var greyOut = "_3a-2";
export var initialsColor0 = "_3a-3";
export var initialsColor1 = "_3a-4";
export var initialsColor10 = "_3a-d";
export var initialsColor11 = "_3a-e";
export var initialsColor2 = "_3a-5";
export var initialsColor3 = "_3a-6";
export var initialsColor4 = "_3a-7";
export var initialsColor5 = "_3a-8";
export var initialsColor6 = "_3a-9";
export var initialsColor7 = "_3a-a";
export var initialsColor8 = "_3a-b";
export var initialsColor9 = "_3a-c";
export var initialsWrapper = "_3a-1";
export var large = "_3a-l";
export var medium = "_3a-k";
export var mediumSmall = "_3a-j";
export var mediumSmallMedium = "_3a-o";
export var micro = "_3a-h";
export var small = "_3a-i";
export var tiny = "_3a-n";
export var xTiny = "_3a-m";